// Predictable keys for testing
var nextKey = 1;
export default function getNextKey() {
  return "" + nextKey++;
}